import * as React from 'react';
import './index.css';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import toast, { Toaster } from 'react-hot-toast';
import css from 'css';
import { AuthValidatorContext } from '../../contexts/auth';

import { useState, useEffect } from 'react';
import { useContext } from 'react';
import { SettingsBannerContext } from '../../contexts/SettingsBannerContext';
import { Api } from './api/generate';
import { Padding } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  Padding: '90px',
  bgcolor: 'background.paper',
  borderRadius: '15px',
  p: 4,
  transition: 'box-shadow 0.3s ease',
  cursor: 'pointer',
  boxShadow: 'none',
  border: 'transparent',
  '&:focus':{
    outline: 'none'
  },
  
  '&:hover': {
    boxShadow: '0px 0px 15px 5px rgba(0, 0, 0, 0.3)',
  },
};


export const GenerateAnimationAI = () => {

  const [animationInput, setAnimationInput] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { setLoading, setAiAnimation} = useContext(SettingsBannerContext);
  const { roles } = useContext(AuthValidatorContext);

const notifyError = (message) => toast.error(message);
const notifySuccess = (message) => toast.success(message);

const checkKeyWord = (inputValue) => {
  let inputKeyWords = inputValue.includes('anime') || inputValue.includes('animação') || inputValue.includes('keyframe') || inputValue.includes('crie') || inputValue.includes('gere') || inputValue.includes('faça')
  if(inputKeyWords === true ){ return true;}else{ return false;}
  }

  async function onSubmit(event) {
    event.preventDefault();

  function addOpacity(cssCode) {
    var contexto = cssCode
    contexto = contexto.replace("0% {","0% { opacity:1;")
    contexto = contexto.replace("100% {","100% { opacity:1;")
    return contexto
    }


    const checkOpacity = (cssCode) => {
      let cssCodeKeyWords = cssCode.includes('opacity') || cssCode.includes('opacity:');
      if(cssCodeKeyWords === true ){ return true;}else{ return false;}
      }

      if(animationInput.includes(',') === false || animationInput.trim().length === 0){
        notifyError('Insira uma instrução valida');
        setAnimationInput("");
        return;
      }
 
    if (checkKeyWord(animationInput) === true) {
        setLoading({show: true, progress: false});
        handleClose();
        const result = await Api.Generate(animationInput)
        if (result === null || result.length === 0) {
          notifyError('Houve um erro na requisição')
          setLoading({show: false, progress: false})
         return
        } 
        else {
          let data = result;
          let check = checkOpacity(data)
          if(check === false){
            let transform = addOpacity(data);
            data = transform;
          }
          setAiAnimation(data)
          setAnimationInput("");
          notifySuccess('Sucesso confira ao lado sua animação');
          setLoading({show: false, progress: false})
        }
      } 
      
      
      else {
        notifyError('Insira uma instrução valida');
        setAnimationInput("");
      }
      setLoading({show: false, progress: false});
      return
    }
  
    return (
    <div>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <button className={roles.ia_resources === 1 ? "ai-btn" : "ai-btn-disabled"}
        onClick={handleOpen}
        disabled={roles.ia_resources !== 1}
      >
      <svg
          className={'svg-AiIcon'}
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
      <path d="M320 238.933333L213.333333 298.666667l59.733334-106.666667L213.333333 85.333333l106.666667 59.733334L426.666667 85.333333 366.933333 192 426.666667 298.666667 320 238.933333m512 418.133334L938.666667 597.333333l-59.733334 106.666667L938.666667 810.666667l-106.666667-59.733334L725.333333 810.666667l59.733334-106.666667L725.333333 597.333333l106.666667 59.733334M938.666667 85.333333l-59.733334 106.666667L938.666667 298.666667l-106.666667-59.733334L725.333333 298.666667l59.733334-106.666667L725.333333 85.333333l106.666667 59.733334L938.666667 85.333333m-369.493334 459.946667l104.106667-104.106667-90.453333-90.453333-104.106667 104.106667 90.453333 90.453333m43.946667-234.24l99.84 99.84c16.64 15.786667 16.64 43.52 0 60.16L215.04 968.96c-16.64 16.64-44.373333 16.64-60.16 0l-99.84-99.84c-16.64-15.786667-16.64-43.52 0-60.16L552.96 311.04c16.64-16.64 44.373333-16.64 60.16 0z" fill="" />
      </svg>
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box 
        className='modal-ai'
        sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2" style={{display: "flex", justifyContent: 'space-between'}}>
          <div style={{width: '80px', marginTop: '-30px'}}>
            <p style={{fontSize:'15px', fontWeight:'lighter', color: 'rgba(115, 115, 115, 0.656)'}}>Versão Beta</p>
          </div>

          <div style={{width: '80px'}}>
            <svg
            style={{
              width: '1.5em',
              height: '1.5em',
              verticalAlign: 'middle',
              fill: 'rgba(115, 115, 115, 0.156)',
              overflow: 'hidden',
            }}
            
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M320 238.933333L213.333333 298.666667l59.733334-106.666667L213.333333 85.333333l106.666667 59.733334L426.666667 85.333333 366.933333 192 426.666667 298.666667 320 238.933333m512 418.133334L938.666667 597.333333l-59.733334 106.666667L938.666667 810.666667l-106.666667-59.733334L725.333333 810.666667l59.733334-106.666667L725.333333 597.333333l106.666667 59.733334M938.666667 85.333333l-59.733334 106.666667L938.666667 298.666667l-106.666667-59.733334L725.333333 298.666667l59.733334-106.666667L725.333333 85.333333l106.666667 59.733334L938.666667 85.333333m-369.493334 459.946667l104.106667-104.106667-90.453333-90.453333-104.106667 104.106667 90.453333 90.453333m43.946667-234.24l99.84 99.84c16.64 15.786667 16.64 43.52 0 60.16L215.04 968.96c-16.64 16.64-44.373333 16.64-60.16 0l-99.84-99.84c-16.64-15.786667-16.64-43.52 0-60.16L552.96 311.04c16.64-16.64 44.373333-16.64 60.16 0z" fill="" />
              </svg>
          </div>

        
          <div style={{width: '80px'}}>
            <button className='btn-close' onClick={handleClose}>
            <CloseIcon fontSize="large"/>
            </button>
          </div>
          </Typography>
      
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <ul>
              <li>Insira o nome da animação </li>
              <li>adicione uma “,”  </li>
              <li>Descreva as características da animação</li>
            </ul>
            <span className='example'> <b>Ex:</b> piscando, crie um keyframe que dure 3s e entre piscando e saia com fade</span>
          </Typography>
          <form onSubmit={onSubmit} autocomplete="off">
          <div style={{display: 'flex', margin: '1rem auto'}}>
          <input
          className='ai-input'
          type="text"
          name="animation"
          value={animationInput}
          onChange={(e) => setAnimationInput(e.target.value)}
          placeholder='piscando, crie um keyframe que dure 3s e entre piscando e saia com fade'          
          />
          <button className='generate' type='submit'>
            <SendIcon/>
            </button>
          </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}